<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
  <div class="container-fluid">
    <!-- Brand -->
    <!-- Form -->
    <!-- <form
      class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"
    >
      <div class="form-group mb-0" [ngClass]="{ focused: focus === true }">
        <div class="input-group input-group-alternative">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input
            class="form-control"
            placeholder="Buscar"
            type="text"
            (focus)="focus = true"
            (blur)="focus = false"
          />
        </div>
      </div>
    </form> -->
    <!-- User -->
    <ul class="navbar-nav align-items-center d-none d-md-flex ml-lg-auto">
      <!-- <li
        class="nav-item"
        ngbDropdown
        placement="bottom-right"
        style="padding-right: 20px;"
      >
        <h3 class="mb-0 text-white">IESS</h3>
      </li> -->
      <!-- <li
        class="nav-item"
        ngbDropdown
        placement="bottom-right"
        style="padding-right: 20px;"
      >
        <i class="fa fa-cog fa-2x" style="color: #fff;"></i>
      </li>
      <li
        class="nav-item"
        ngbDropdown
        placement="bottom-right"
        style="padding-right: 20px;"
      >
        <i class="fa fa-bell fa-2x" style="color: #fff;"></i>
      </li> -->
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <i class="fa fa-user fa-2x" style="color: #fff;" ngbDropdownToggle></i>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <!-- <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Bienvenido!</h6>
          </div> -->
          <!-- <a
            routerLinkActive="active"
            [routerLink]="['/perfil']"
            class="dropdown-item"
          >
            <i class="ni ni-single-02"></i>
            <span>Mi Perfil</span>
          </a>
          <a
            routerLinkActive="active"
            [routerLink]="['/user-profile']"
            class="dropdown-item"
          >
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </a>
          <a
            routerLinkActive="active"
            [routerLink]="['/user-profile']"
            class="dropdown-item"
          >
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </a>
          <a
            routerLinkActive="active"
            [routerLink]="['/user-profile']"
            class="dropdown-item"
          >
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </a>
          <div class="dropdown-divider"></div> -->
          <a (click)="Logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Cerrar sesión</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
